import React, { memo, useMemo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useSuggestedTags from 'Pods/SearchPage/Shared/useSuggestedTags'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearKeyword } from 'Pods/SearchPage/Store/actions/keyword'
import { addTag, clearTags, removeTag } from 'Pods/SearchPage/Store/actions/tags'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import TermChip from './Components/TermChip/TermChip'

// Selected terms stay in here rather than in the filter row (accepted design, CU-124g39pbfna).
function Panel({ onTermChange }) {
  const translate = useTranslate()
  const trackFilterSelect = useTrackFilterSelect()

  const keyword = useSearchPageStore(state => state.keyword)
  const selectedTags = useSearchPageStore(state => state.tags)
  const suggestedTags = useSuggestedTags()

  const relatedTags = useMemo(() => {
    const selectedSet = new Set(selectedTags)
    return suggestedTags.filter(tag => !selectedSet.has(tag))
  }, [selectedTags, suggestedTags])

  const handleAdd = (tag) => {
    trackFilterSelect(FILTER_NAME.TAGS, tag)
    addTag(tag)
    onTermChange()
  }

  const handleRemove = (tag) => {
    removeTag(tag)
    onTermChange()
  }

  const handleReset = () => {
    clearKeyword()
    clearTags()
  }

  return (
    <div className="search-within__content">
      {selectedTags.length > 0 && (
        <div
          className="search-within__selected"
          role="group"
          aria-label={translate('search_page.filters.search_within.selected_group_label')}
        >
          {selectedTags.map(tag => (
            <TermChip
              key={tag}
              label={tag}
              removeLabel={translate('search_page.filters.search_within.remove_term', { term: tag })}
              onRemove={handleRemove}
            />
          ))}
        </div>
      )}
      {relatedTags.length > 0 && (
        <div className="search-within__related">
          <span id="search-within-related-title" className="search-within__related-title cgt-overline-md">
            {translate('search_page.filters.search_within.related_searches')}
          </span>
          <div className="search-within__related-tags" role="group" aria-labelledby="search-within-related-title">
            {relatedTags.map(tag => (
              <Button
                key={tag}
                type="secondary"
                size="tiny"
                actionType="button"
                onClick={() => handleAdd(tag)}
                customClass="search-within__related-tag"
              >
                {tag}
              </Button>
            ))}
          </div>
        </div>
      )}
      <Button
        type="ghost-primary"
        size="small"
        actionType="button"
        customClass="filter-wrapper__reset-button filter-wrapper__reset-button--inline search-within__reset"
        onClick={handleReset}
        disabled={keyword === '' && selectedTags.length === 0}
      >
        {translate('search_page.filters.tags.reset')}
      </Button>
    </div>
  )
}

Panel.propTypes = {
  onTermChange: func.isRequired,
}

export default memo(Panel)
